import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import formatDatetime from '../../intl/dateTime/formatDateTime.js';
import 'luxon';
import 'styled-components';
import 'lodash';
import '../icons/ActivityIcon.js';
import '../icons/ArrowDownIcon.js';
import '../icons/ArrowDownRightCircleIcon.js';
import '../icons/ArrowLeftAlignIcon.js';
import '../icons/ArrowLeftIcon.js';
import '../icons/ArrowRightAlignIcon.js';
import '../icons/ArrowRightIcon.js';
import '../icons/ArrowSwitchIcon.js';
import '../icons/ArrowUpIcon.js';
import '../icons/ArrowUpRightCircleIcon.js';
import '../icons/ArrowsAngleExpandIcon.js';
import '../icons/BankIcon.js';
import '../icons/CheckIcon.js';
import '../icons/ChevronDownIcon.js';
import '../icons/ChevronRightIcon.js';
import '../icons/ChevronUpIcon.js';
import '../icons/CopyIcon.js';
import '../icons/CrossIcon.js';
import '../icons/DaiIcon.js';
import '../icons/DangerIcon.js';
import '../icons/DownSortIcon.js';
import '../icons/ExclamationTriangleIcon.js';
import '../icons/ExpandKpiIcon.js';
import '../icons/EyeIcon.js';
import '../icons/EyeSlashIcon.js';
import '../icons/Grid1x2Icon.js';
import '../icons/InfoCircleIcon.js';
import '../icons/ListIcon.js';
import '../icons/LockIcon.js';
import '../icons/MediumIcon.js';
import '../icons/MoonIcon.js';
import '../icons/PiggyBankIcon.js';
import '../icons/QuestionMarkCircleIcon.js';
import '../icons/ShieldIcon.js';
import '../icons/SunIcon.js';
import '../icons/UpSortIcon.js';
import '../icons/XIcon.js';
import '../icons/InfinityIcon.js';
import '../icons/ArrowUpRightBoxIcon.js';
import '../molecules/CurrencyValue/components/Value.js';
import '../../theme/GlobalStyle.js';
import 'react-helmet-async';
import '../../theme/ThemedComponentWrapper.js';
import '../molecules/KpiCard/KpiCard.js';
import '../molecules/PercentageValue.js';
import '../molecules/Tabs/Tabs.js';
import '../molecules/TrendValue.js';
import '../pictograms/EthPictogram.js';
import '../pictograms/EtherScanPictogram.js';
import '../pictograms/DebankPictogram.js';
import '../pictograms/ZapperPictogram.js';
import '../pictograms/DaiPictogram.js';
import '../molecules/Modal/Modal.js';
import '@floating-ui/react';
import '../charts/ChartKpis/ChartKpi.js';
import '../charts/ChartJS.js';
import '../charts/Heatmap/Heatmap.js';
import 'randomcolor';
import 'd3';
import '../XRay.js';
import 'ethereum-blockies-base64';
import Box from './layout/Box/Box.js';
import './layout/Stack/Stack.js';
import './Table/components/Pagination/Pagination.js';
import './Table/Table.js';
import './ToggleSwitch.js';
import TooltipContent from './Tooltip/components/TooltipContent.js';
import TooltipTrigger from './Tooltip/components/TooltipTrigger.js';
import Tooltip from './Tooltip/Tooltip.js';

function RelativeDateTime({ value, formatDateTimeOptions, ...rest }) {
    const options = useMemo(() => ({
        toRelativeUnit: 'days',
        ...formatDateTimeOptions
    }), [formatDateTimeOptions]);
    return (jsxs(Tooltip, { children: [jsx(TooltipTrigger, { variant: "nowrap", children: jsx(Box, { ...rest, name: "relativeDateTime", children: formatDatetime(value, options) }) }), jsx(TooltipContent, { children: formatDatetime(value, { showTime: true }) })] }));
}

export { RelativeDateTime as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
